import Loader from "@helpers/loader/loader";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, Col, Container, Image, Navbar, Row, Form, FloatingLabel, Button } from "react-bootstrap";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import useWindowResize from "@customHooks/useWindowResize";
import { Typography } from "@mui/material";
import TitleDashboard from "@components/general/Titles/TitleDashboard";
import DirectorioTelefonico from "@components/usuario/CompraLicencia/modals/directorioTelefonico/DirectorioTelefonico";
import AvisoPrivacidad from "@components/usuario/CompraLicencia/modals/avisoPrivacidad/AvisoPrivacidad";
import GridPaquetes from "@components/usuario/CompraLicencia/GridPaquetes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { createCheckoutSession, getPriceAbono } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import Swal from "sweetalert2";
import { Notificacion } from "@components/general/Alertas/Alertas";
import UserContext from "@context/User/UserContext";
import stripe from "@helpers/stripe/stripe";
import { useLocation } from "react-router-dom";
import { extraerRegionesSai } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";

const AbonoLicencia = () => {

	const {t} = useTranslation();

	const urlParams = new URLSearchParams(useLocation().search);

	const { contextValue, setContextValue } = useContext(UserContext);

	const [showLoader, setShowLoader] = useState(true);

	const [loading, setLoading] = useState(false);

	const [showModalAvisoPrivacidad, setShowModalAvisoPrivacidad] = useState(false);

	const [showModalDirectorioTelefonico, setShowModalDirectorioTelefonico] = useState(false);

	const [precioStripe, setPrecioStripe] = useState("");

	const [folioContrato, setFolioContrato] = useState("");

	const [esCompraExterna, setEsCompraExterna] = useState(false);

	const [regionesSai, setRegionesSai] = useState([]);

	const [regionSeleccionada, setRegionSeleccionada] = useState(0);

	const darkTheme = createTheme({
		palette: {
			mode: "dark",
		},
	});

	const {
		size: { width },
	} = useWindowResize();

	const handleClickAvisoPrivacidad = () => {
		setShowModalAvisoPrivacidad(!showModalAvisoPrivacidad);
	};

	const handleClickDirectorioTelefonico = () => {
		setShowModalDirectorioTelefonico(!showModalDirectorioTelefonico);
	};

	const handleClickPreguntasFrecuentes = () => {
		let link = document.createElement("a");

		link.href = "https://globalclickmexico.com/faq/index.html";

		link.target = "_blank";

		link.dispatchEvent(new MouseEvent("click"));
	};

	const handleOnChange = ({ target }) => {
		setFolioContrato(target.value.replace(/\D/g, ""));
	};

	const generarCheckout = async (folioContratoParam = null) => {
		//TODO validar  si es compra externa o no
		try {
			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.abonoRealizado}${esCompraExterna ? '?payment-succesfull=true' : ''}`,
				cancel_url: folioContratoParam === null ? `${window.location.origin}${dashboardRoutesPaths.pagos.abonoLicencia}${esCompraExterna ? '?license-payment=true': ''}` : `${window.location.origin}${dashboardRoutesPaths.pagos.abonoLicencia}?folioContrato=${folioContratoParam}${esCompraExterna ? '?license-payment=true': ''}`,
				line_items: [{ price: precioStripe, quantity: 1 }],
				mode: "payment",
				currency: esCompraExterna ? 'usd' : "mxn",
				metadata: {
					folioContrato: folioContratoParam === null ? folioContrato : folioContratoParam,
					metodoPago: "contado",
				},
			};

			const checkoutSession = await createCheckoutSession(sessionData);

			if (urlParams.get("folioContrato") === null) {
				const { isConfirmed } = await Swal.fire({
					title: t('leavingClick'),
					text: t('leavingClickMessage'),
					showCancelButton: true,
					reverseButtons: true,
					confirmButtonText: t('ok'),
					cancelButtonText: t('Cancel'),
					confirmButtonColor: "#0d6efd",
					allowOutsideClick: false,
				});

				if (!isConfirmed) {
					return Notificacion("info", "El pago fue cancelado");
				}
			}

			setContextValue({
				...contextValue,
				stripeSession: checkoutSession,
				folioContrato: folioContratoParam === null ? folioContrato : folioContratoParam,
				idRegion: regionSeleccionada,
				isMobile: folioContratoParam === null ? false : true
			});

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		} catch (error) {
			console.log("Error al generar el checkout de pago: ", error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if(regionSeleccionada === 0 || folioContrato === ''){
			NotificationManager.error("Por favor, selecciona tu ubicación y coloca tu folio de contrato.");
			return;
		}

		try {
			setLoading(true);

			await generarCheckout();

			if (urlParams.get("folioContrato") === null) {
				setLoading(false);
			}
		} catch (error) {
			console.log("error al iniciar el pago de abono: ", error);

			setLoading(false);
		}
	};

	const consultarPrecioAbono = async () => {
		try {
			const montoLibre = true;

			
		 //Se reciben los datos para manejarlos en la vista pública
		 const param = new URLSearchParams(window.location.search);

		 const datosURL = param.get("license-payment");
		 //Transformamos el string del data en arreglo

			const { idPrecio } = await getPriceAbono(montoLibre, datosURL !== null ? true: false);

			setPrecioStripe(idPrecio);

			if (urlParams.get("folioContrato") === null) {
				setShowLoader(false);
			}
		} catch (error) {
			console.log("error al iniciar el pago de abono: ", error);
		}
	};

	const consultarRegiones = async() => {
		try{
			const regiones = await extraerRegionesSai();
			console.log(regiones)
			if(Array.isArray(regiones.data)){
				setRegionesSai(regiones.data);
			}else{
				setRegionesSai([regiones.data]);
			}
		}catch(error){
			console.log("Hubo un error al recuperar las regiones del SAI");
		}
	};

	const handleOnChangeRegion = ({target}) => {
		const {name, value} = target;
		console.log(name, value)
		setRegionSeleccionada(parseInt(value))
	};

	useEffect(() => {
		// setShowLoader(false);

		 //Se reciben los datos para manejarlos en la vista pública
		 const param = new URLSearchParams(window.location.search);

		 const datosURL = param.get("license-payment");
		 //Transformamos el string del data en arreglo

		 consultarRegiones()

		 if(datosURL !== null) {
			setEsCompraExterna(true);
		 }

		 //Si la variable datosURL es diferente de null es una compra fuera de México

		if (precioStripe === "") {
			consultarPrecioAbono();
		}
	}, []);

	useEffect(() => {
		if (precioStripe !== "") {
			const folioContratoParam = urlParams.get("folioContrato");

			console.log("folio param: ", folioContratoParam);

			if (folioContratoParam !== null) {
				// setFolioContrato(folioContratoParam);

				generarCheckout(folioContratoParam);

				// formRef?.current.click();
			}
		}
	}, [precioStripe]);

	return (
		<>
			{showLoader ? (
				<Loader />
			) : (
				<ThemeProvider theme={darkTheme}>
					<CssBaseline />

					<div data-bs-theme="dark" className="bg-main-container d-flex flex-column" style={{ overflow: "hidden", overflowY: "scroll" }}>
						<Navbar expand="lg" bg="dark" className="bg-dark-custom">
							<Container fluid>
								<Navbar.Brand href="#">
									<div className="m-1">
										<img className="pointer" src={require(`@assets/images/logo-gc-horizontal.png`)} alt="Logo Global Click" style={{ width: `${width > 992 ? "10vw" : "20vw"}` }} />
									</div>
								</Navbar.Brand>

								<div className="text-white d-flex justify-content-end">
									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickAvisoPrivacidad}>
										Aviso de privacidad
									</Typography>

									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickPreguntasFrecuentes}>
										Preguntas frecuentes
									</Typography>

									<Typography variant="overline" className="pointer px-3 hover-orange" onClick={handleClickDirectorioTelefonico}>
										Directorio telefónico
									</Typography>
								</div>
							</Container>
						</Navbar>

						<Container className="py-30">
							<Row>
								<Col>
									<Container className="bg-light-dark card">
										<Row className="text-white">
											<Col>
												<Container className="py-3">
													<TitleDashboard title="Abono de Licencia Plataforma Click+" />

													<GridPaquetes />

													<TitleDashboard title="Ingresa tu Folio de Contrato" />

													<Form onSubmit={handleSubmit} className="mt-3 mx-4">

														<Row className="mb-3">
																<Col>
																	<Form.Select name="region" onChange={handleOnChangeRegion} size="lg" aria-label="Default select example">
																		<option>Selecciona tu ubicación</option>
																		{regionesSai.map((region, idxRegion) => (
																			<option key={idxRegion} value={region.regionId}>{region.nombreRegion}</option>
																		))}
																	</Form.Select>
																</Col>
														</Row>
														<FloatingLabel label="Folio de Contrato" className="mb-3">
															<Form.Control maxLength={5} type="text" placeholder="Folio de contrato" name="folioContrato" value={folioContrato} onChange={handleOnChange} />
														</FloatingLabel>

														

														<div className="d-grid gap-2">
															<Button type="submit" variant="primary" size="lg">
																Pagar {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : null}
															</Button>
														</div>
													</Form>
												</Container>
											</Col>
										</Row>
									</Container>
								</Col>
							</Row>
						</Container>

						<Container fluid className="p-0 align-content-end" style={{ flex: 1 }}>
							<Row>
								<Col>
									<Card>
										<Card.Body className="p-0">
											<Image fluid src={require("@assets/images/compra/compra-footer.jpg")} alt="Footer de Global Click México" className="w-100 h-100" />
										</Card.Body>
									</Card>
								</Col>
							</Row>
						</Container>

						<DirectorioTelefonico modalShow={showModalDirectorioTelefonico} setModalShow={setShowModalDirectorioTelefonico} />

						<AvisoPrivacidad modalShow={showModalAvisoPrivacidad} setModalShow={setShowModalAvisoPrivacidad} />
					</div>
				</ThemeProvider>
			)}
		</>
	);
};

export default AbonoLicencia;
